import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';

import { FlexRow } from 'ui-components/components/flex';
import { CollapsibleListSection } from 'ui-components/components/collapsible-list/collapsible-list-section';
import { CollapsibleListSectionHeader } from 'ui-components/components/collapsible-list/collapsible-list-section-header';
import { CollapsibleListSectionContent } from 'ui-components/components/collapsible-list/collapsible-list-section-content';

import styles from './collapsible.module.css';
import { useManageSubscriptionDrawerContext } from '../../../context/manage-subscription-drawer-context';

export const Collapsible = ({ className, headerContent, sectionContent, sectionId }) => {
  const { expandedSections, setExpandedSections } = useManageSubscriptionDrawerContext();
  const onClickHeader = useCallback(() => {
    const newExpandedSet = new Set(expandedSections);
    if (newExpandedSet.has(sectionId)) {
      newExpandedSet.delete(sectionId);
    } else {
      newExpandedSet.add(sectionId);
    }
    setExpandedSections(newExpandedSet);
  }, [expandedSections, sectionId, setExpandedSections]);

  return (
    <FlexRow>
      <CollapsibleListSection className={classnames(styles.section, className)} open={expandedSections.has(sectionId)}>
        <CollapsibleListSectionHeader className={styles['section-header']} onClick={onClickHeader} theme='white'>
          <label className={styles.title} htmlFor={sectionId}>
            {headerContent}
          </label>
        </CollapsibleListSectionHeader>
        <CollapsibleListSectionContent className={styles['section-content']} id={sectionId}>
          {sectionContent}
        </CollapsibleListSectionContent>
      </CollapsibleListSection>
    </FlexRow>
  );
};

Collapsible.propTypes = {
  className: PropTypes.string,
  headerContent: PropTypes.node.isRequired,
  sectionContent: PropTypes.node.isRequired,
  sectionId: PropTypes.string.isRequired,
};
